import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { createBrowserHistory } from 'history';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'connected-react-router';
import logger from 'redux-logger';

import createRootReducer from './store/rootReducer';
import rootSaga from './store/rootSaga';

const sagaMiddleware = createSagaMiddleware();
export const history = createBrowserHistory();

const middlewares = [routerMiddleware(history), sagaMiddleware];

if (process.env.NODE_ENV !== 'production') {
  middlewares.push(logger);
}

const store = configureStore({
  reducer: createRootReducer(history),
  // https://redux-toolkit.js.org/api/getDefaultMiddleware for reference
  middleware: [
    ...getDefaultMiddleware({
      thunk: false,
      serializableCheck: {
        ignoredActionPaths: ['payload.request', 'payload.error', 'payload'],
      },
    }),
  ].concat(middlewares),
});

sagaMiddleware.run(rootSaga);
export default store;
